// extracted by mini-css-extract-plugin
export default {"title":"uSID5PLO","subTitle":"ggZVQMYZ"};